import { SideNavItem } from './models/sideNavItem';

export const SIDENAV_ITEMS_DEVICE: Array<SideNavItem> = [
  {
    reportId: 'iotDeviceMarketShare',
    title: 'Market Share',
    id: 'device-market-share',
    mapId: 'device-market-share',
    active: false,
    groups: ['app', 'ctv']
  },
  {
    reportId: 'iotDeviceReach',
    title: 'Reach',
    id: 'device-reach',
    mapId: 'device-reach',
    active: false,
    groups: ['app', 'ctv']
  }
];
